export default __webpack_public_path__ + "static/media/check.c9a94acd.svg";